import { checkTouchSupport } from './_utils.js';

export default function touch() {
	const hasTouchSupport = checkTouchSupport();
	if (!hasTouchSupport) {
		$(document.body).addClass('no-touch');
	} else {
		$(document.body).addClass('touch');
	}
}
